// Friendly relative date+time for "checked out / borrowed" timestamps.
//   today      -> "today, 8:59 AM"
//   yesterday  -> "yesterday, 8:33 AM"
//   older      -> "Jun 5" (adds the year if it's a previous year)
export function relativeWhen(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  const now = new Date();
  const startOfDay = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate());
  const dayDiff = Math.round((startOfDay(now) - startOfDay(d)) / 86400000);
  const time = d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });

  if (dayDiff === 0) return `today, ${time}`;
  if (dayDiff === 1) return `yesterday, ${time}`;
  const sameYear = d.getFullYear() === now.getFullYear();
  return d.toLocaleDateString(
    undefined,
    sameYear ? { month: "short", day: "numeric" } : { month: "short", day: "numeric", year: "numeric" },
  );
}
